function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1351",
  transform: "translate(-576.538 -398.538)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 1043",
  width: 22.92,
  height: 22.923,
  rx: 3,
  transform: "translate(576.538 398.538)",
  fill: "#2c2c2e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 87",
  d: "M587.999 403.538a6.462 6.462 0 106.462 6.462 7.267 7.267 0 00-.072-.976 3.88 3.88 0 11-5.413-5.413 7.267 7.267 0 00-.977-.073z",
  fill: "#f4f4f4"
}));

function SvgDarkModeLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.92 22.923"
  }, props), _ref);
}

export default SvgDarkModeLabel;